'use strict'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Experience from './Experience.js'

export default class Camera
{
  constructor()
  {
    this.experience = new Experience()
    this.sizes = this.experience.sizes
    this.scene = this.experience.scene
    this.canvas = this.experience.canvas

    this.setInstance()
    this.setOrbitControls()
  }

  setInstance()
  {
    this.instance = new THREE.PerspectiveCamera( 35, this.sizes.width / this.sizes.height, 0.1, 100 )
    this.instance.position.set(4, 4, 8)
    this.scene.add(this.instance)
  }
  setOrbitControls()
  {
    this.controls = new OrbitControls(this.instance, this.canvas)
    this.controls.minDistance = 4
    this.controls.maxDistance = 32
    this.controls.maxPolarAngle = Math.PI * 0.45
    this.controls.enableDamping = true
  }
  resize()
  {
    this.instance.aspect = this.sizes.width / this.sizes.height
    this.instance.updateProjectionMatrix()
  }
  update()
  {
    this.controls.update()
  }
}